import get from "lodash/get";

import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import DateInput from "../inputs/date-input";

import { DATE_FORMATS } from "../../constants";
import { getValidDates } from "../../utils/date-helpers";
import { RillContext, useRillContext } from "../../rill/RillReact/share/base";

const { DATE_PICKER_FORMAT, DATE_DAY_FORMAT } = DATE_FORMATS;

const CalendarDuplicateWorkoutModal = (props) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { activeExercises, query } = locals;
  const [submited, setSubmited] = useState(false);
  const [validDates, setValidDates] = useState(getValidDates(activeExercises));

  const handleSubmit = (e) => {
    if (submited) {
      e.preventDefault();
      return;
    }
    setSubmited(true);
  };

  const dateValidator = (pickerDate) => {
    const formattedPickerDate = moment(pickerDate).format(DATE_DAY_FORMAT);

    return validDates[formattedPickerDate];
  };

  const activeDay = moment.utc(query.day, DATE_DAY_FORMAT).startOf("day");
  const queryDate = get(query, "modal.date");

  const [exportDate, setExportDate] = useState(
    (queryDate &&
      moment.utc(queryDate, DATE_DAY_FORMAT).format(DATE_PICKER_FORMAT)) ||
      null
  );

  return (
    <form
      action={`/actions/exercise/copy-day?proxyAthlete=${query.athlete}&reqSource=calendar`}
      method="POST"
      data-noreset
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="type" value="duplicate" />
      <input type="hidden" name="from" value={activeDay.toJSON()} />

      <Modal
        className="Duplicate-Workout export-workout"
        title={t("calendarDuplicateWorkout.title")}
        toClear={["day"]}
      >
        <div className="body">
          <label htmlFor="">{t("calendarDuplicateWorkout.todaysDate")}</label>
          <p className="s1">{activeDay.format(DATE_PICKER_FORMAT)}</p>

          <label htmlFor="to" className="mt-6">
            {t("calendarDuplicateWorkout.duplicateWorkoutTo")}
          </label>
          <DateInput
            name="to"
            defaultValue={exportDate}
            dateValidator={(date) => dateValidator(date, locals)}
            placeholder={t("calendarDuplicateWorkout.selectDate")}
            onChange={(date) => {
              setExportDate(date);
            }}
          />
        </div>

        <footer>
          <a
            role="button"
            data-button-type="text-white"
            data-action="cancel"
            href="/actions/refresh?modal[type]=&day="
          >
            {t("common:cancel")}
          </a>
          <button
            disabled={
              !exportDate || !moment(exportDate).isValid() ? true : undefined
            }
            role="button"
            data-button-type="primary"
            type="submit"
          >
            {t("calendarDuplicateWorkout.duplicate")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default CalendarDuplicateWorkoutModal;
